import React, { useState, useRef } from 'react';
import { Filter, Check, ChevronDown } from 'lucide-react';
import { useClickOutside } from '../../../../../app/hooks/useClickOutside';
import { motion, AnimatePresence } from 'framer-motion';
interface FilterDropdownProps {
  label: string;
  options: {
    id: string;
    label: string;
  }[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  badgeColor?: 'blue' | 'purple';
}
export function FilterDropdown({
  label,
  options,
  selectedValues,
  onChange,
  badgeColor = 'blue'
}: FilterDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useClickOutside(containerRef, () => setIsOpen(false));
  const toggleOption = (id: string) => {
    if (selectedValues.includes(id)) {
      onChange(selectedValues.filter(v => v !== id));
    } else {
      onChange([...selectedValues, id]);
    }
  };
  const badgeClass = badgeColor === 'blue' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700';
  return <div className="relative" ref={containerRef} data-id="element-5762">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border text-sm font-medium transition-colors
          ${isOpen ? 'border-gray-300 bg-gray-50' : 'border-gray-200 bg-white hover:bg-gray-50 text-gray-700'}`} data-id="element-5763">
        <Filter className="w-4 h-4 text-gray-500" data-id="element-5764" />
        {label}
        {selectedValues.length > 0 && <span className={`ml-1 px-1.5 py-0.5 rounded-md text-[10px] font-bold ${badgeClass}`} data-id="element-5765">
            {selectedValues.length}
          </span>}
        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-5766" />
      </button>

      <AnimatePresence data-id="element-5767">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 4,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 4,
        scale: 0.95
      }} transition={{
        duration: 0.15
      }} className="absolute z-10 top-full left-0 mt-1 w-56 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-5768">
            <div className="p-2 max-h-64 overflow-y-auto" data-id="element-5769">
              {options.map(option => {
            const isSelected = selectedValues.includes(option.id);
            return <button key={option.id} onClick={() => toggleOption(option.id)} className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm text-left hover:bg-gray-50 transition-colors" data-id="element-5770">
                    <span className={isSelected ? 'font-medium text-gray-900' : 'text-gray-700'} data-id="element-5771">
                      {option.label}
                    </span>
                    {isSelected && <Check className={`w-4 h-4 ${badgeColor === 'blue' ? 'text-blue-600' : 'text-purple-600'}`} data-id="element-5772" />}
                  </button>;
          })}
            </div>
            {selectedValues.length > 0 && <div className="p-2 border-t border-gray-100 bg-gray-50" data-id="element-5773">
                <button onClick={() => onChange([])} className="w-full px-3 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 transition-colors" data-id="element-5774">
                  Wissen
                </button>
              </div>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}